import React, { Fragment, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Col } from 'react-bootstrap';

const Home = () => {

  const [homeCasino, setCasino] = useState([]);
  const [loading, setLoading] = useState(true);

  const data = {
    key_s: 'eyJ0eXAiOiJKV1Qidfg%!#%$%LCdf#*&*JhbGciOiJSUzI1NiJ9',
  };

  const APiResponse = () => {
    axios.post('/game-list', data)
      .then(response => {
        setCasino(response.data.home_casino);
        setLoading(false);
      })
      .catch(error => {
        console.log(error);
      });
  };

  useEffect(() => {
    const interval = setInterval(
      (function callApi() {
        APiResponse();
        return callApi;
      })(),
      70000000
    );
    return () => clearInterval(interval);
  }, []);

  return (
    <Fragment>
      <div className="container py-5">
        <h2 className="text-center mb-5 text-dark">Explore Casino Games 🎰</h2>
        <div className="row g-4">
          {homeCasino.map((ele) => (
            <Col key={ele.id} xl="4" lg="4" md="6" sm="12">
              <Link to={`/casino-game/${ele.id}/${ele.slug}`} className="text-decoration-none">
                <div className="card h-100 border-0 shadow-sm rounded-4 game-card hover-zoom">
                  <div className="overflow-hidden rounded-top-4">
                    <img src={ele.image} alt={ele.name} className="img-fluid w-100" style={{ height: "220px", objectFit: "cover" }} />
                  </div>
                  <div className="card-body text-center">
                    <h5 className="card-title text-dark mb-2">{ele.name}</h5>
                    <button className="btn btn-outline-success btn-sm px-4">Play Now</button>
                  </div>
                </div>
              </Link>
            </Col>
          ))}
        </div>
      </div>

      {/* Extra CSS */}
      <style>{`
        .game-card {
          transition: transform 0.3s, box-shadow 0.3s;
        }
        .game-card:hover {
          transform: translateY(-10px);
          box-shadow: 0 12px 24px rgba(0,0,0,0.2);
        }
      `}</style>
    </Fragment>
  );
};

export default Home;
